import styled from "styled-components";
import { motion } from "framer-motion";
import colors from "../../constants/colors";

export const ToastContainer = styled(motion.div)({
  position: "fixed",
  top: "1rem",
  // Center via left/right/margin auto — framer-motion overrides `transform`
  // on the animated element, so a `translateX(-50%)` centering trick would
  // be dropped, letting the toast overflow off-screen on mobile.
  left: 0,
  right: 0,
  marginInline: "auto",
  zIndex: 9999,
  maxWidth: "500px",
  width: "calc(100% - 2rem)",
  cursor: "pointer",
});

export const ToastContent = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  padding: "0.875rem 1rem",
  direction: "rtl",
  background: colors.PURPLE_LIGHTEST,
  color: colors.PURPLE,
  borderRadius: "12px",
  border: `1.5px solid ${colors.PURPLE}20`,
  boxShadow: `0 4px 12px ${colors.SHADOW_PURPLE_LIGHT}`,
  fontSize: "0.875rem",
  fontWeight: 600,
  lineHeight: 1.3,
  textAlign: "right",
});
